<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            label="일자"
            name="srchDts"
            :range="true"
            v-model="searchParam.srchDts"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="grid"
      title="시설운전사항"
      tableId="grid"
      :columns="grid.columns"
      :data="grid.data"
      :usePaging="true"
      :columnSetting="false"
      :filtering="true"
      :isExcelDown="false"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn v-if="editable && grid.data.length > 0" label="SEMS 다운로드" icon="download" @btnClicked="downLoadSems"/>
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'air-sems-01',
  data() {
    return {
      editable: true,
      searchParam: {
        plantCd: null,
        srchYear: '',
        srchDts: [],
      },
      grid: {
        columns: [
          {
            name: 'dailyResultDt',
            field: 'dailyResultDt',
            label: '일자',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstOutletName',
            field: 'envAirMstOutletName',
            label: '배출구일련번호',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstOutletSems',
            field: 'envAirMstOutletSems',
            label: '허가증상배출구번호',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstOutletNm',
            field: 'envAirMstOutletNm',
            label: '배출구명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstPreventiveNo',
            field: 'envAirMstPreventiveNo',
            label: '방지시설일련번호',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstPreventiveNum',
            field: 'envAirMstPreventiveNum',
            label: '사내고유방지시설번호',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstPreventiveName',
            field: 'envAirMstPreventiveName',
            label: '방지시설명',
            align: 'center',
            sortable: false,
          },
          {
            name: 'wattmeterFlag',
            field: 'wattmeterFlag',
            label: '전력계부착여부',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstWattmeterNo',
            field: 'envAirMstWattmeterNo',
            label: '적산전력계번호',
            align: 'center',
            sortable: false,
          },
          {
            name: 'wattmeterMagnification',
            field: 'wattmeterMagnification',
            label: '전력계배율',
            align: 'center',
            sortable: false,
          },
          {
            name: 'todayScore',
            field: 'todayScore',
            label: '전력 검침량(kWh)',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstDrug1Name',
            field: 'envAirMstDrug1Name',
            label: '약품명1',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstDrug1Volume',
            field: 'envAirMstDrug1Volume',
            label: '사용량1',
            align: 'center',
            sortable: false,
          },
          {
            name: 'airDrugUnitName1',
            field: 'airDrugUnitName1',
            label: '단위1',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstDrug2Name',
            field: 'envAirMstDrug2Name',
            label: '약품명2',
            align: 'center',
            sortable: false,
          },
          {
            name: 'envAirMstDrug2Volume',
            field: 'envAirMstDrug2Volume',
            label: '사용량2',
            align: 'center',
            sortable: false,
          },
          {
            name: 'airDrugUnitName2',
            field: 'airDrugUnitName2',
            label: '단위2',
            align: 'center',
            sortable: false,
          },
        ],
        data: [],
      },
      listUrl: '',
      saveUrl: '',
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  computed: {
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.env.air.sems.oprequips.list.url;
      this.editable = this.$route.meta.editable;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param =this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    downLoadSems() {
      let thisVue = this;
      this.$http.url = selectConfig.env.air.sems.oprequips.list.url + '/excel';
      this.$http.param =this.searchParam;
      this.$http.type = 'GET';
      this.$http.request((_result) => {
          var blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, "SEMS시설운전사항엑셀양식.xlsx");
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "SEMS시설운전사항엑셀양식.xlsx";
            link.click();
          }
      },);
    },
  }
};
</script>
